import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana12Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_33264)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M647.246 625.632L613.378 499.072L565.129 554.469L647.084 625.733C647.158 625.798 647.271 625.727 647.246 625.632Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M606.229 649.182C641.969 649.182 648.521 633.099 647.329 625.951L581.211 568.768L545.472 609.868L606.229 649.182Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M599.083 443.678L613.379 499.074L565.13 554.47L529.391 524.092L599.083 443.678Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M486.499 572.342L545.469 609.869L581.209 568.768L529.387 524.094L486.499 572.342Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M579.431 372.199L599.087 443.678L583.005 461.548L525.821 411.513C532.969 401.982 549.052 380.776 556.2 372.199C563.348 363.621 574.665 368.625 579.431 372.199Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M525.823 411.512L583.006 461.547L549.053 500.861L491.87 450.825L525.823 411.512Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M459.704 488.351L491.869 450.824L549.053 500.86L515.1 540.173L459.704 488.351Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M429.321 522.304L459.699 488.352L515.096 540.174L486.504 572.34C469.826 561.618 435.396 539.102 431.108 534.813C426.819 530.524 428.129 524.687 429.321 522.304Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_33264" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_33264" transform="matrix(0.00245114 0 0 0.00324955 -5.9255 -0.906283)"/>
    </pattern>
    <image id="image0_1466_33264" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};